import { render, staticRenderFns } from "./TableRiskAppraisalBsgs.vue?vue&type=template&id=a34c6eb2&scoped=true"
import script from "./TableRiskAppraisalBsgs.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalBsgs.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalBsgs.vue?vue&type=style&index=0&id=a34c6eb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34c6eb2",
  null
  
)

export default component.exports